// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { xScreen } from "@awc/XDL/Utilities";
import { signInExistingAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInExistingAccount";
import { FormFieldIcon } from "@insite/mobius/FormField";
import { css } from "styled-components";

signInExistingAccountStyles.signInGridContainer = {
    gap: 12,
};

signInExistingAccountStyles.signInExistingAccountTitle = {
    variant: "h2",
    css: css`
        &:empty {
            display: none;
        }
    `,
};

signInExistingAccountStyles.signInButtonGridItem = {
    width: 12,
    css: css`
        justify-content: space-between;
        align-items: center;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            gap: 16px;
            align-items: start;
        }
    `,
};

signInExistingAccountStyles.forgotPasswordLink = {
    typographyProps: {
        size: fontConfig.fontSize.xSmall,
        lineHeight: fontConfig.lineHeight.xSmall,
        weight: fontConfig.weight.bold,
    },
};

signInExistingAccountStyles.resetPasswordModal = {
    sizeVariant: "small",
    cssOverrides: {
        modalBody: css`
            &&& {
                max-width: 450px;
            }
        `,
    },
};

signInExistingAccountStyles.forgotPasswordGridItem = {
    width: 12,
    css: css`
        justify-content: start;
    `,
};

signInExistingAccountStyles.userNameGridItem = signInExistingAccountStyles.passwordGridItem = {
    width: [12, 12, 12, 6, 6],
};

signInExistingAccountStyles.signInButton = { variant: "tertiary" };

signInExistingAccountStyles.passwordTextField = {
    cssOverrides: {
        formInputWrapper: css`
            ${FormFieldIcon} {
                background: transparent;
            }
        `,
    },
};
